var e = "11.2.0-DEV+unknown";
//#endregion
export { e as REPORT_PACKAGE_VERSION };
